module.exports = __webpack_public_path__ + "static/media/Skin_tone_7.82460517.svg";